(() => {
  const qs = (root, sel) => (root || document).querySelector(sel);
  const qsa = (root, sel) => Array.from((root || document).querySelectorAll(sel));
  const desktopMq = () => window.matchMedia('(min-width: 990px)').matches;

  function carousel(root) {
    if (!root) return;
    const slides = qsa(root, '[data-lova-slide]');
    if (!slides.length) return;

    const track = qs(root, '[data-lova-track]');
    const viewport = qs(root, '[data-lova-viewport]') || track?.parentElement;
    const prevs = qsa(root, '[data-lova-prev]');
    const nexts = qsa(root, '[data-lova-next]');
    const dots = qsa(root, '[data-lova-dot]');
    const isPalette = root.hasAttribute('data-lova-palette');
    const loop = root.dataset.loop !== 'false';
    const transitionMs = Number(root.dataset.transition) || 450;
    const gapDesktop = Number(root.dataset.gapDesktop);
    const gapMobile = Number(root.dataset.gapMobile);
    const visibleDesktop = Number(root.dataset.visibleDesktop) || 3;
    const visibleMobile = Number(root.dataset.visibleMobile) || 1;
    const autoplayEnabled = root.dataset.autoplayEnabled === 'true';
    const autoplayMs = Number(root.dataset.autoplay) || 5000;
    let index = 0;
    let autoplayTimer = null;

    function transitionCss() {
      return `transform ${transitionMs}ms ease`;
    }

    function perView() {
      if (!desktopMq()) return Math.max(1, visibleMobile);
      return Math.min(Math.max(1, visibleDesktop), slides.length);
    }

    function gapSize() {
      if (desktopMq()) {
        return Number.isFinite(gapDesktop) ? gapDesktop : 28;
      }
      return Number.isFinite(gapMobile) ? gapMobile : 0;
    }

    function measure() {
      if (!viewport) return { width: 0, gap: 0, step: 0, pv: 1 };
      const pv = perView();
      const gap = gapSize();
      const width = Math.max(0, (viewport.clientWidth - gap * (pv - 1)) / pv);
      return { width, gap, step: width + gap, pv };
    }

    function layout() {
      const { width, gap, pv } = measure();
      slides.forEach((slide, n) => {
        slide.hidden = false;
        slide.style.flexBasis = `${width}px`;
        slide.style.width = `${width}px`;
        slide.style.minWidth = `${width}px`;
        slide.style.maxWidth = `${width}px`;
        slide.style.marginRight = n === slides.length - 1 ? '0px' : `${gap}px`;
        slide.style.order = '';
      });
      if (track) {
        track.style.gap = '0px';
        track.style.justifyContent = 'flex-start';
      }
      return { width, gap, step: width + gap, pv };
    }

    function maxStart(pv) {
      return Math.max(0, slides.length - pv);
    }

    function normalizeIndex(i, pv) {
      if (pv === 1) {
        if (loop) return ((i % slides.length) + slides.length) % slides.length;
        return Math.max(0, Math.min(i, slides.length - 1));
      }
      const max = maxStart(pv);
      if (loop) {
        if (i < 0) return max;
        if (i > max) return 0;
        return i;
      }
      return Math.max(0, Math.min(i, max));
    }

    function updateChrome(pv) {
      slides.forEach((slide, n) => {
        const visible = pv === 1 ? n === index : n >= index && n < index + pv;
        slide.classList.toggle('is-active', visible);
        slide.setAttribute('aria-hidden', visible ? 'false' : 'true');

        if (isPalette) {
          if (pv === 1) {
            slide.classList.toggle('lova-palette__slide--featured', n === index);
            slide.classList.toggle('lova-palette__slide--side', n !== index);
          } else {
            const center = index + Math.floor(pv / 2);
            const featured = n === center;
            slide.classList.toggle('lova-palette__slide--featured', featured);
            slide.classList.toggle('lova-palette__slide--side', !featured);
          }
        }
      });

      dots.forEach((dot, n) => {
        const on = n % slides.length === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || slides.length < 2 || autoplayMs < 1000) return;
      autoplayTimer = setInterval(() => show(index + 1), autoplayMs);
    }

    function show(i) {
      const { step, pv } = layout();

      // Palette with <=3 slides on desktop: keep all visible, rotate featured center
      if (isPalette && desktopMq() && slides.length <= pv) {
        const next = loop
          ? ((i % slides.length) + slides.length) % slides.length
          : Math.max(0, Math.min(i, slides.length - 1));
        const forward = ((next - index + slides.length) % slides.length) === 1
          || ((next - index + slides.length) % slides.length) <= Math.floor(slides.length / 2);
        const dir = forward ? -1 : 1;
        index = next;

        slides.forEach((slide, n) => {
          const visual = (n - index + slides.length) % slides.length;
          slide.style.order = String(visual);
          slide.hidden = false;
          slide.setAttribute('aria-hidden', 'false');
          const featured = slides.length < 3 ? visual === 0 : visual === 1;
          slide.classList.toggle('lova-palette__slide--featured', featured);
          slide.classList.toggle('lova-palette__slide--side', !featured);
          slide.classList.toggle('is-active', featured);
        });

        if (track) {
          track.style.transition = 'none';
          track.style.transform = `translate3d(${-dir * 56}px, 0, 0)`;
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              track.style.transition = transitionCss();
              track.style.transform = 'translate3d(0, 0, 0)';
            });
          });
        }

        dots.forEach((dot, n) => {
          const on = n % slides.length === index;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-current', on ? 'true' : 'false');
        });
        return;
      }

      index = normalizeIndex(i, pv);
      if (track) {
        track.style.transition = transitionCss();
        track.style.transform = `translate3d(-${index * step}px, 0, 0)`;
      }
      updateChrome(pv);
    }

    function go(delta) {
      show(index + delta);
      startAutoplay();
    }

    prevs.forEach((el) =>
      el.addEventListener('click', (event) => {
        event.preventDefault();
        go(-1);
      })
    );
    nexts.forEach((el) =>
      el.addEventListener('click', (event) => {
        event.preventDefault();
        go(1);
      })
    );
    dots.forEach((dot, n) =>
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        show(n % slides.length);
        startAutoplay();
      })
    );

    // Touch / swipe — horizontal only; vertical page scroll stays free
    let touchX = 0;
    let touchY = 0;
    let tracking = false;
    let axisLocked = '';
    let didSwipe = false;
    const surface = viewport || root;
    const swipeThreshold = 36;

    surface.addEventListener(
      'touchstart',
      (event) => {
        if (!event.touches[0] || slides.length < 2) return;
        tracking = true;
        axisLocked = '';
        didSwipe = false;
        touchX = event.touches[0].clientX;
        touchY = event.touches[0].clientY;
        stopAutoplay();
      },
      { passive: true }
    );

    surface.addEventListener(
      'touchmove',
      (event) => {
        if (!tracking || !event.touches[0]) return;
        const dx = event.touches[0].clientX - touchX;
        const dy = event.touches[0].clientY - touchY;

        if (!axisLocked) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          axisLocked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }

        if (axisLocked === 'x') {
          event.preventDefault();
        } else {
          tracking = false;
        }
      },
      { passive: false }
    );

    surface.addEventListener(
      'touchend',
      (event) => {
        if (!tracking || !event.changedTouches[0]) {
          tracking = false;
          startAutoplay();
          return;
        }
        tracking = false;
        const dx = event.changedTouches[0].clientX - touchX;
        const dy = event.changedTouches[0].clientY - touchY;
        if (axisLocked === 'x' && Math.abs(dx) >= swipeThreshold && Math.abs(dx) > Math.abs(dy)) {
          didSwipe = true;
          go(dx < 0 ? 1 : -1);
        } else {
          startAutoplay();
        }
        axisLocked = '';
      },
      { passive: true }
    );

    surface.addEventListener(
      'click',
      (event) => {
        if (!didSwipe) return;
        event.preventDefault();
        event.stopPropagation();
        didSwipe = false;
      },
      true
    );

    // Pointer support (pen); touch is handled above
    let pointerX = null;
    let pointerY = null;
    surface.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'pen' || slides.length < 2) return;
      pointerX = event.clientX;
      pointerY = event.clientY;
      stopAutoplay();
    });
    surface.addEventListener('pointerup', (event) => {
      if (pointerX == null || event.pointerType !== 'pen') return;
      const dx = event.clientX - pointerX;
      const dy = event.clientY - pointerY;
      pointerX = null;
      pointerY = null;
      if (Math.abs(dx) < swipeThreshold || Math.abs(dx) <= Math.abs(dy)) {
        startAutoplay();
        return;
      }
      didSwipe = true;
      go(dx < 0 ? 1 : -1);
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => show(index), 120);
    });

    show(0);
    startAutoplay();
  }

  function heroMatchesVisibility(root) {
    const mode = root.dataset.visibility || 'all';
    if (mode === 'all') return true;
    const isDesktop = window.matchMedia('(min-width: 769px)').matches;
    if (mode === 'desktop') return isDesktop;
    if (mode === 'mobile') return !isDesktop;
    return true;
  }

  function pauseHeroVideos(root) {
    qsa(root, 'video').forEach((video) => {
      video.pause();
      video.removeAttribute('autoplay');
      try {
        video.currentTime = 0;
      } catch {
        // ignore
      }
    });
  }

  function heroCarousel(root) {
    if (!root) return;
    if (!heroMatchesVisibility(root)) {
      pauseHeroVideos(root);
      root._lovaHeroStop?.();
      delete root.dataset.lovaHeroReady;
      return;
    }
    if (root.dataset.lovaHeroReady === 'true') return;
    root.dataset.lovaHeroReady = 'true';
    const slides = qsa(root, '[data-lova-hero-slide]');
    const pips = qsa(root, '[data-lova-hero-pip]');
    if (!slides.length) return;

    let index = 0;
    let timer = null;
    let ignoringFocus = false;
    const delay = Number(root.dataset.autoplay) || 4000;
    const autoplayEnabled = root.dataset.autoplayEnabled !== 'false';
    const loop = root.dataset.loop !== 'false';
    const pauseOnHover = root.dataset.pauseOnHover !== 'false';
    const pauseOnInteraction = root.dataset.pauseOnInteraction !== 'false';
    const transitionMs = Number(root.dataset.transition);
    if (Number.isFinite(transitionMs) && transitionMs > 0) {
      root.style.setProperty('--lova-hero-transition', `${transitionMs}ms`);
    }

    function show(i, { restart = true } = {}) {
      if (loop) {
        index = ((i % slides.length) + slides.length) % slides.length;
      } else {
        index = Math.max(0, Math.min(i, slides.length - 1));
      }
      ignoringFocus = true;
      slides.forEach((slide, n) => {
        const on = n === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        const link = slide.querySelector('.lova-hero__link');
        if (link) {
          if (on) link.removeAttribute('tabindex');
          else link.setAttribute('tabindex', '-1');
        }
        qsa(slide, 'video').forEach((video) => {
          if (on) {
            video.play().catch(() => {});
          } else {
            video.pause();
            try {
              video.currentTime = 0;
            } catch {
              // ignore
            }
          }
        });
      });
      pips.forEach((pip, n) => {
        const on = n === index;
        pip.classList.toggle('is-active', on);
        pip.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      window.requestAnimationFrame(() => {
        ignoringFocus = false;
      });
      if (restart) start();
    }

    function start() {
      stop();
      if (!autoplayEnabled || slides.length < 2 || delay < 1000) return;
      timer = window.setTimeout(() => {
        if (!loop && index >= slides.length - 1) {
          stop();
          return;
        }
        show(index + 1, { restart: false });
        start();
      }, delay);
    }

    function stop() {
      if (timer != null) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    root._lovaHeroStop = stop;

    pips.forEach((pip, n) => {
      pip.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        show(n, { restart: true });
      });
    });

    const controls = qs(root, '.lova-hero__controls');
    if (pauseOnHover && controls) {
      controls.addEventListener('mouseenter', stop);
      controls.addEventListener('mouseleave', start);
    }
    if (pauseOnInteraction && controls) {
      controls.addEventListener('focusin', (event) => {
        if (ignoringFocus) return;
        if (event.target.closest('[data-lova-hero-pip]')) stop();
      });
      controls.addEventListener('focusout', (event) => {
        if (ignoringFocus) return;
        if (!controls.contains(event.relatedTarget)) start();
      });
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stop();
        slides.forEach((slide) => {
          qsa(slide, 'video').forEach((video) => video.pause());
        });
      } else {
        start();
        qsa(slides[index], 'video').forEach((video) => {
          video.play().catch(() => {});
        });
      }
    });

    show(0);
  }

  function initLovaHeroes(scope) {
    qsa(scope || document, '[data-lova-hero]').forEach(heroCarousel);
  }

  function refreshLovaHeroVisibility() {
    qsa(document, '[data-lova-hero]').forEach((hero) => {
      hero._lovaHeroStop?.();
      delete hero.dataset.lovaHeroReady;
      pauseHeroVideos(hero);
      heroCarousel(hero);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initLovaHeroes());
  } else {
    initLovaHeroes();
  }
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) initLovaHeroes(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    const heroes = event.target.matches('[data-lova-hero]')
      ? [event.target]
      : qsa(event.target, '[data-lova-hero]');
    heroes.forEach((hero) => {
      hero._lovaHeroStop?.();
      delete hero.dataset.lovaHeroReady;
      pauseHeroVideos(hero);
    });
  });
  window.matchMedia('(min-width: 769px)').addEventListener('change', refreshLovaHeroVisibility);
  document.querySelectorAll('[data-lova-palette]').forEach(carousel);
  document.querySelectorAll('[data-lova-diary]').forEach(carousel);

  const menuBtn = document.querySelector('[data-lova-menu-open]');
  const menu = document.querySelector('[data-lova-menu]');
  const menuClose = document.querySelector('[data-lova-menu-close]');
  menuBtn?.addEventListener('click', () => menu?.showModal());
  menuClose?.addEventListener('click', () => menu?.close());
  menu?.addEventListener('click', (event) => {
    if (event.target === menu) menu.close();
  });

  function setLovaCartCount(count) {
    const n = Math.max(0, Number(count) || 0);
    document.querySelectorAll('[data-lova-cart-count]').forEach((el) => {
      el.textContent = String(n);
      if (n === 0) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });
    document.querySelectorAll('[data-lova-open-cart]').forEach((el) => {
      el.setAttribute('aria-label', `Cart, ${n} items`);
    });
    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({ value: String(n), timestamp: Date.now() })
      );
    } catch {
      /* ignore */
    }
  }

  function refreshLovaCartCount() {
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart.js`, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart && typeof cart.item_count === 'number') setLovaCartCount(cart.item_count);
      })
      .catch(() => {});
  }

  function onLovaCartLinesUpdate(event) {
    const apply = (payload) => {
      const count =
        payload?.cart?.totalQuantity ??
        payload?.cart?.item_count ??
        payload?.detail?.itemCount ??
        payload?.itemCount;
      if (typeof count === 'number') setLovaCartCount(count);
      else refreshLovaCartCount();
    };

    if (event?.promise && typeof event.promise.then === 'function') {
      event.promise.then(apply).catch(() => refreshLovaCartCount());
      return;
    }
    apply(event);
  }

  document.addEventListener('shopify:cart:lines-update', onLovaCartLinesUpdate);
  document.addEventListener('cart:update', () => refreshLovaCartCount());

  document.querySelectorAll('[data-lova-open-cart]').forEach((el) => {
    el.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        drawer.open();
      }
    });
  });

  document.querySelectorAll('[data-lova-open-search]').forEach((el) => {
    el.addEventListener('click', (event) => {
      const modal = document.querySelector('#search-modal');
      if (modal && typeof modal.showDialog === 'function') {
        event.preventDefault();
        modal.showDialog();
      }
    });
  });
})();
